import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const LANGUAGES = {
	en: 'en',
	fr: 'fr',
	es: 'es',
} as const satisfies Record<string, string>;

export type Language = (typeof LANGUAGES)[keyof typeof LANGUAGES];

export const DEFAULT_LANGUAGE = LANGUAGES.en;

i18next
	.use(I18NextHttpBackend)
	.use(I18nextBrowserLanguageDetector)
	.use(initReactI18next)
	.init({
		supportedLngs: Object.values(LANGUAGES),
		fallbackLng: DEFAULT_LANGUAGE,
		react: {
			useSuspense: true,
		},
		detection: {
			order: ['cookie', 'navigator'],
			caches: ['cookie'],
		},
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json',
		},
		ns: ['common', 'errors'],
	});

export { i18next };
